/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_SelfhostInputs */

const en_mk_foot_selfhost = /** @type {(inputs: Mk_Foot_SelfhostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosting`)
};

const id_mk_foot_selfhost = /** @type {(inputs: Mk_Foot_SelfhostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-host`)
};

/**
* | output |
* | --- |
* | "Self-hosting" |
*
* @param {Mk_Foot_SelfhostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_selfhost = /** @type {((inputs?: Mk_Foot_SelfhostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_SelfhostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_selfhost(inputs)
	return en_mk_foot_selfhost(inputs)
});